import {
  Checkbox,
  Flex,
  FlexItem,
  InputNumber,
  Text
} from 'mailup-web-components'
import {
  handleHours,
  handleMinutes,
  MAX_INPUT_TIME,
  MIN_INPUT_TIME
} from 'Pages/Workflow/components/Step4/SendingTime'
import { step4ValidData } from 'Pages/Workflow/recoil/state/data'
import { step4State } from 'Pages/Workflow/recoil/state/step4'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState, useSetRecoilState } from 'recoil'

const BlackoutHours = () => {
  const intl = useIntl()
  const [{ BlackoutStartHour, BlackoutEndHour }, setWorkflowDetails] =
    useRecoilState(step4State)
  const setValidBOHours = useSetRecoilState(step4ValidData)
  const [typingHourStart, setTypingHourStart] = useState(false)
  const [typingMinuteStart, setTypingMinuteStart] = useState(false)
  const [typingHourEnd, setTypingHourEnd] = useState(false)
  const [typingMinuteEnd, setTypingMinuteEnd] = useState(false)

  const [checkedBOHours, setCheckedBOHours] = useState(
    BlackoutStartHour !== null && true
  )

  const handleCheckbox = () => {
    setCheckedBOHours(!checkedBOHours)
  }

  const [startBOTime, setStartBOTime] = useState({
    hours: BlackoutStartHour === null ? 0 : BlackoutStartHour.slice(11, 13),
    minutes: BlackoutStartHour === null ? 0 : BlackoutStartHour.slice(14, 16),
    hoursVariant: undefined,
    minutesVariant: undefined
  })

  const [endBOTime, setEndBOTime] = useState({
    hours: BlackoutEndHour === null ? 0 : BlackoutEndHour.slice(11, 13),
    minutes: BlackoutEndHour === null ? 0 : BlackoutEndHour.slice(14, 16),
    hoursVariant: undefined,
    minutesVariant: undefined
  })

  const handleStartBOHour = (value) => {
    handleHours(value, setStartBOTime, startBOTime)
  }
  const handleStartBOMinute = (value) => {
    handleMinutes(value, setStartBOTime, startBOTime)
  }
  const handleEndBOHour = (value) => {
    handleHours(value, setEndBOTime, endBOTime)
  }
  const handleEndBOMinute = (value) => {
    handleMinutes(value, setEndBOTime, endBOTime)
  }

  useEffect(() => {
    if (BlackoutStartHour === null) {
      setCheckedBOHours(false)
    }
  }, [BlackoutStartHour])

  useEffect(() => {
    setWorkflowDetails((prev) => ({
      ...prev,
      BlackoutStartHour: checkedBOHours
        ? `2000-01-01T${String(startBOTime.hours).padStart(2, '0')}:${String(
            startBOTime.minutes
          ).padStart(2, '0')}:00Z`
        : null,
      BlackoutEndHour: checkedBOHours
        ? `2000-01-01T${String(endBOTime.hours).padStart(2, '0')}:${String(
            endBOTime.minutes
          ).padStart(2, '0')}:00Z`
        : null
    }))
  }, [checkedBOHours, startBOTime, endBOTime])

  useEffect(() => {
    if (
      startBOTime.hoursVariant === 'danger' ||
      startBOTime.minutesVariant === 'danger' ||
      endBOTime.hoursVariant === 'danger' ||
      endBOTime.minutesVariant === 'danger'
    ) {
      setValidBOHours((prev) => ({
        ...prev,
        validBlackoutHours: false
      }))
    } else {
      setValidBOHours((prev) => ({
        ...prev,
        validBlackoutHours: true
      }))
    }
  }, [
    startBOTime.hoursVariant,
    startBOTime.minutesVariant,
    endBOTime.hoursVariant,
    endBOTime.minutesVariant
  ])

  return (
    <Flex flexDirection='column' margin='0 0 0 24px'>
      <Flex margin='8px 0 0 0' alignItems='baseline'>
        <Checkbox
          checked={checkedBOHours}
          onChange={handleCheckbox}
          label={intl.formatMessage({
            id: 'Load.AutomationWorkflow.PauseTrigger'
          })}
        />
      </Flex>
      {checkedBOHours && (
        <Flex flexDirection='column' margin='0 0 0 24px'>
          <Flex margin='8px 0 0 0' alignItems='baseline' columnGap='8px'>
            <Text>
              {intl.formatMessage({
                id: 'Load.AutomationWorkflow.RestrictionDateFrom'
              })}
            </Text>
            <FlexItem width='70px'>
              <InputNumber
                value={String(startBOTime.hours)}
                onChange={handleStartBOHour}
                onFocus={() => setTypingHourStart(true)}
                onBlur={() => setTypingHourStart(false)}
                formatter={(value) => {
                  if (typingHourStart) {
                    return value
                  } else {
                    return value.toString().padStart(2, '0')
                  }
                }}
                variant={startBOTime.hoursVariant}
                min={MIN_INPUT_TIME}
                max={MAX_INPUT_TIME}
                precision={0}
              />
            </FlexItem>
            <FlexItem width='70px'>
              <InputNumber
                value={startBOTime.minutes}
                onChange={handleStartBOMinute}
                onFocus={() => setTypingMinuteStart(true)}
                onBlur={() => setTypingMinuteStart(false)}
                formatter={(value) => {
                  if (typingMinuteStart) {
                    return value
                  } else {
                    return value.toString().padStart(2, '0')
                  }
                }}
                variant={startBOTime.minutesVariant}
                min={MIN_INPUT_TIME}
                max={MAX_INPUT_TIME}
                step={5}
                precision={0}
              />
            </FlexItem>
            <Text>
              {intl.formatMessage({
                id: 'Load.AutomationWorkflow.RestrictionDateTo'
              })}
            </Text>
            <FlexItem width='70px'>
              <InputNumber
                value={endBOTime.hours}
                onChange={handleEndBOHour}
                onFocus={() => setTypingHourEnd(true)}
                onBlur={() => setTypingHourEnd(false)}
                formatter={(value) => {
                  if (typingHourEnd) {
                    return value
                  } else {
                    return value.toString().padStart(2, '0')
                  }
                }}
                variant={endBOTime.hoursVariant}
                min={MIN_INPUT_TIME}
                max={MAX_INPUT_TIME}
                precision={0}
              />
            </FlexItem>
            <FlexItem width='70px'>
              <InputNumber
                value={endBOTime.minutes}
                onChange={handleEndBOMinute}
                onFocus={() => setTypingMinuteEnd(true)}
                onBlur={() => setTypingMinuteEnd(false)}
                formatter={(value) => {
                  if (typingMinuteEnd) {
                    return value
                  } else {
                    return value.toString().padStart(2, '0')
                  }
                }}
                variant={endBOTime.minutesVariant}
                min={MIN_INPUT_TIME}
                max={MAX_INPUT_TIME}
                step={5}
                precision={0}
              />
            </FlexItem>
          </Flex>
        </Flex>
      )}
    </Flex>
  )
}

export default BlackoutHours
